import ReactionList from './ReactionList.component';

export default ReactionList;